<template>
    <div class="container" v-if="isLoggedIn">
        <h1>Hello! You have successfully logged in to {{ $appName }}.</h1>
        <div class="row justify-content-center">
            <div class="col-12">
            </div>
            <div class="col-12">
                <p>This portal is managing the workflows between ACTRIS National Facilities (NF), ACTRIS Centre for Aerosol Remote Sensing (CARS) and the Aerosol remote Sensing unit of the ACTRIS Data Centre (ARES) throughout the labelling process:</p>
                <ul class="mb-3 va-unordered">
                <li>The initial acceptance of the NFs (Step 1a)</li>
                <li>The management of the QA/QCs actions (Step 1b)</li>
                <li>The approval of the label (Step 1c)</li>
                <li>The regular evaluation (Step 2)</li>
                </ul>
                <el-collapse>
                    <el-collapse-item>
                        <template #title>
                            <el-icon class="mr2">
                                <InfoFilled />
                            </el-icon>More information about the workflow
                        </template>
                        <div class="pa-4">
                            <p><strong>If you are a NF PI, this is what you should do in {{ $appName }}:</strong></p>
                            <ul class="mb-3 va-unordered">
                            <li>Fill in and update detailed information about the aerosol remote sensing instrumentation >>> necessary for labelling, all steps</li>
                            <li>Submit lidar QA/QC tests for CARS analysis >>> necessary to check and (re)approve the operational configuration of your lidar(s)</li>
                            <li>Request additional support from CARS (direct comparison, laboratory characterisation of components, expert visit for debugging the lidar, hands-on training, etc.) >>> necessary when you encounter a problem with the lidar that you cannot solve by yourself, or when CARS recommends</li>
                            <li>View reports issued by CARS.</li>
                            </ul>
                            <p><strong>If you are a member of CARS, this is what you should do in {{ $appName }}:</strong></p>
                            <ul class="mb-3 va-unordered">
                            <li>Evaluate the applications of the registered NFs, and make recommendations </li>
                            <li>Schedule operation support (QA/QC tests or other) to be provided to each registered NF</li>
                            <li>Input reports for each operation support provided to the NFs</li>
                            <li>Pack and send to ARES the parameters for the operational configuration of the lidar(s) </li>
                            <li>Create custom reports to track back the activities performed with each NF</li>
                            </ul>
                            <p>The workflow diagram is shown below.</p>
                            <el-image :ratio="1779/761" contain :src="require('@/public/img/carport-workflow.png')" />
                            <p>Note that {{ $appName }} sends notifications via email to all actors involved (the PI of the concerned NF, CARS and ARES) whenever an important action takes place. When notified, please check if a certain action is expected from you and proceed via {{ $appName }}.</p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>
    <div class="container" v-else><!-- Not logged in -->
        <h1>Welcome to the CARS workflow management portal!</h1>
        <div class="row justify-content-center">
            <div class="col-12">
                <p>This portal is managing the workflows between ACTRIS National Facilities (NF), ACTRIS Centre for Aerosol Remote Sensing (CARS) and the Aerosol remote Sensing unit of the ACTRIS Data Centre (ARES).</p>
                <p>Through this portal:</p>
                <ul class="mb-3 va-unordered">
                <li>ACTRIS aerosol remote sensing NFs submit and update detailed information about their instruments, submit lidar QA/QC information and data, and request for additional support from CARS</li>
                <li>CARS schedules the specific support for each NF, evaluates the lidar QA/QC information and issues reports</li>
                <li>CARS approves the operational configuration which are used by ARES to process lidar data</li>
                </ul>
                <p>The portal can be accessed only by registered users. The registration of a new user is done by {{ $appName }} administrator at the request of the ACTRIS HO to start the labelling process.</p>
                <p>If you experience problems in logging in, please contact {{ $appName }} from the <strong><router-link :to="{name: 'ContactPage'}">contact page</router-link></strong></p>
            </div>
        </div>
    </div>
    <div class="container mt-5">
        <h2>Aerosol Remote Sensing facilities</h2>
        <div style="height: 600px">
        <FacilityMap />
    </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

import FacilityMap from '@/components/facilities/FacilityMap.vue'

export default {
    name: 'HomePage',
    components: {FacilityMap},
    computed: {
      ...mapGetters ('auth', ['isLoggedIn'])
    }
}
</script>